module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$abs.row.pa > -1) ? _c('div', {
    staticClass: "abs-testo"
  }, [(false) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Tipoeditor " + _vm._s(typeof _vm.$teras.evento.tipoeditor) + " » " + _vm._s(_vm.$teras.evento.allegato) + "   ")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.titolo,
      "prop": "titolo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$teras.lang.titoloHolder
    },
    model: {
      value: (_vm.$abs.row.titolo),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "titolo", $$v)
      },
      expression: "$abs.row.titolo"
    }
  })], 1), _vm._v(" "), ((typeof _vm.$teras.evento.tipoeditor != 'undefined')) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.testo
    }
  }, [_c('tinymce', {
    attrs: {
      "initvalue": _vm.$abs.row.testo,
      "height": "300",
      "language": _vm.$teras.language
    },
    on: {
      "change": _vm.testoChange
    },
    model: {
      value: (_vm.$abs.row.testo),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "testo", $$v)
      },
      expression: "$abs.row.testo"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row pad help"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col s10",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.datitestoHelp)
    }
  })]), _vm._v(" "), (_vm.$abs.row.wordcount > _vm.$teras.evento.maxparole) ? _c('div', {
    staticClass: "row pad help",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col s10"
  }, [_vm._v("\n        " + _vm._s(_vm.$teras.lang.maxparoleWarning) + ": " + _vm._s(_vm.$teras.evento.maxparole) + "  \n    ")])]) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.parolechiave == 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.parolechiave,
      "prop": "parolechiave"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$teras.lang.parolechiaveHolder
    },
    model: {
      value: (_vm.$abs.row.parolechiave),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "parolechiave", $$v)
      },
      expression: "$abs.row.parolechiave"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.allegato == 1) ? _c('div', {
    staticClass: "row help"
  }, [_c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "for": "allegato"
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.allegato))])]), _vm._v(" "), _c('upload', {
    staticClass: "col s10",
    attrs: {
      "value": _vm.$abs.row.allegato,
      "action": "https://api.biomedia.net/201806/vue/upload/",
      "savedir": 'bvent.biomedia.net/abstracts/' + _vm.$teras.evento.id + '/',
      "previewurl": 'https://bvent.biomedia.net/abstracts/' + _vm.$teras.evento.id + '/',
      "extensions": "png,PNG,jpg,JPG,jpeg,JPEG"
    },
    on: {
      "change": function (val) { return _vm.$abs.row.allegato = val; },
      "success": _vm.imageSuccess
    }
  })], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("warning")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06f6d042"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Abs-testo.vue
// module id = 592
// module chunks = 2